module.exports = __webpack_public_path__ + "static/media/image_case_pinjia.11e2c8d5.png";